import { Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Privacy from "./pages/Privacy";
import Term from "./pages/Term";
import "./App.css";
import Disclaimer from "./pages/Disclaimer";
import Cookie from "./pages/Cookie";
import Careers from "./pages/Careers";
import ContestRules from "./pages/contests";

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Term />} />
      <Route path="/disclaimer" element={<Disclaimer />} />
      <Route path="/cookie" element={<Cookie />} />

      <Route path="/careers" element={<Careers />} />
      <Route path="/contest" element={<ContestRules />} />
    </Routes>
  );
};

export default App;
